module.exports = __webpack_public_path__ + "img/prev-maintenance-3.6563510e.jpg";